import axios from "axios";
import { BASE_URL } from "../utils/constants/constants";

export const fetchGuestListReports = async (token, eventId) => {
  try {
    const params = {
      eventId: eventId,
    };

    const response = await axios.post(
      `${BASE_URL}/events/getCompleteMergedReport`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Platform: "web",
          Version: "5.6.1",
        },
      }
    );
    const data = await response.data.payLoad;
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchDashboardReport = async (token, eventId) => {
  try {
    const params = {
      eventId: eventId
    };

    const response = await axios.post(
      `${BASE_URL}/events/getDashboardReport`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Platform: 'web',
          Version: '5.6.1'
        }
      }
    );
    const data = await response.data.payLoad;
    return data;
  } catch (error) {
    throw error;
  }
};
